import {Autocomplete, IconButton, InputAdornment, TextField} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import {FiSearch} from "react-icons/fi";

/**
 * Autocomplete with an optional integrated search icon (`showSearchIcon`).
 * Calls `onSearch` on icon click or Enter key press.
 */
const SearchAutocomplete = ({
  label,
  options = [],
  loading = false,
  value = null,
  inputValue = "",
  onInputChange,
  onChange,
  onSearch,
  width = 220,
  size = "small",
  freeSolo = false,
  showSearchIcon = true
}) => {
  const theme = useTheme();

  return (
    <Autocomplete
      disablePortal
      options={options}
      freeSolo={freeSolo}
      filterOptions={(x) => x}
      // Con `freeSolo` la opción puede ser el texto que ha escrito el usuario.
      getOptionLabel={(option) => (typeof option === "string" ? option : option?.label || "")}
      isOptionEqualToValue={(option, val) => option?.id === val?.id}
      loading={loading}
      value={value}
      inputValue={inputValue}
      onInputChange={onInputChange}
      sx={{width}}
      componentsProps={{
        paper: {
          sx: {
            backgroundColor: theme.palette.colors.background,
            color: theme.palette.text.primary
          }
        }
      }}
      onChange={onChange}
      renderInput={(params) => (
        <TextField
          {...params}
          size={size}
          label={label}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {showSearchIcon && (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onMouseDown={(event) => {
                        event.preventDefault();
                      }}
                      onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        onSearch();
                      }}
                    >
                      <FiSearch />
                    </IconButton>
                  </InputAdornment>
                )}
                {params.InputProps.endAdornment}
              </>
            )
          }}
          inputProps={{
            ...params.inputProps,
            onKeyDown: (e) => {
              if (e.key === "Enter") onSearch();
              params.inputProps?.onKeyDown?.(e);
            }
          }}
        />
      )}
    />
  );
};

export default SearchAutocomplete;
